module.exports = __webpack_public_path__ + "img/ep-carre-wavy.845fdc0f.jpg";